import $ from "jquery";
import { states } from "../constants/States.js";

function phoneFormatting(ele, restore) {
  var new_number,
    selection_start = ele.selectionStart,
    selection_end = ele.selectionEnd,
    number = ele.value.replace(/\D/g, "");

  // automatically add dashes
  if (number.length > 2) {
    // matches: 123 || 123-4 || 123-45
    new_number = "(" + number.substring(0, 3) + ")" + " ";
    if (number.length === 4 || number.length === 5) {
      // matches: 123-4 || 123-45
      new_number += number.substr(3);
    } else if (number.length > 5) {
      // matches: 123-456 || 123-456-7 || 123-456-789
      new_number += number.substring(3, 6) + "-";
    }
    if (number.length > 6) {
      // matches: 123-456-7 || 123-456-789 || 123-456-7890
      new_number += number.substring(6);
    }
  } else {
    new_number = number;
  }

  // if value is heigher than 12, last number is dropped
  // if inserting a number before the last character, numbers
  // are shifted right, only 12 characters will show
  ele.value = new_number.length > 14 ? new_number.substring(0, 14) : new_number;

  // restore cursor selection,
  // prevent it from going to the end
  // UNLESS
  // cursor was at the end AND a dash was added
  if (
    new_number.slice(-1) === " " &&
    restore === false &&
    new_number.length === 6 &&
    selection_end === 3
  ) {
    selection_start = new_number.length;
    selection_end = new_number.length;
  } else if (
    new_number.slice(-1) === "-" &&
    restore === false &&
    new_number.length === 10 &&
    selection_end === 9
  ) {
    selection_start = new_number.length;
    selection_end = new_number.length;
  } else if (restore === "revert") {
    selection_start--;
    selection_end--;
  }
  ele.setSelectionRange(selection_start, selection_end);
}

const utilities = {
  displayDate: function(date) {
    if (date == "0000-00-00") {
      return "Revolving";
    } else {
      var newDate = new Date(
        date
          .toString()
          .replace(/-/g, "/")
          .replace(/T.+/, "")
      );
      var mm = newDate.getMonth() + 1;
      var dd = newDate.getDate();
      var yyyy = newDate.getFullYear();
      return [(mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd, yyyy].join(
        "/"
      );
    }
  },

  focusElement: function(id) {
    $("#" + id).focus();
  },

  goToURL: function(url) {
    if (url.toLowerCase().startsWith("http")) {
      window.open(url);
    } else {
      window.open("http://" + url);
    }
  },

  phoneNumberCheck: function(field, e) {
    var key_code = e.keyCode,
      key_string = String.fromCharCode(key_code),
      press_delete = false,
      dash_key = 189,
      delete_key = [8, 46],
      direction_key = [33, 34, 35, 36, 37, 38, 39, 40],
      selection_end = field.selectionEnd;

    // delete key was pressed
    if (delete_key.indexOf(key_code) > -1) {
      press_delete = true;
    }

    // only force formatting is a number or delete key was pressed
    if (key_string.match(/^\d+$/) || press_delete) {
      phoneFormatting(field, press_delete);
    }
    // do nothing for direction keys, keep their default actions
    else if (direction_key.indexOf(key_code) > -1) {
      // do nothing
    } else if (dash_key === key_code) {
      if (selection_end === field.value.length) {
        field.value = field.value.slice(0, -1);
      } else {
        field.value =
          field.value.substring(0, selection_end - 1) +
          field.value.substr(selection_end);
        field.selectionEnd = selection_end - 1;
      }
    }
    // all other non numerical key presses, remove their value
    else {
      e.preventDefault();
      //    field.value = field.value.replace(/[^0-9\-]/g,'')
      phoneFormatting(field, "revert");
    }
  },

  getStateCode: function(stateString) {
    return states.find(s => s.description == stateString).value;
  },

  createSearchFlag: function(values) {
    var flag = values.reduce((a, b) => a + b, 0);
    if (flag == 0) {
      flag = -1;
    }
    return flag;
  },

  createGrantFlag: function(flagList) {
    if (flagList.length > 0) {
      return flagList.reduce((total, num) => (total += num));
    } else {
      return 0;
    }
  },

  getIndeterminateValue: function(selectedSubjects, subjects, id) {
    var commonVal = selectedSubjects.filter(value => subjects.includes(value))
      .length;
    var el = document.getElementById(id);
    if (el != null) {
      if (commonVal === subjects.length) {
        el.checked = true;
      }
      if (commonVal === 0) {
        el.checked = false;
      }
    }
    return commonVal > 0 && commonVal < subjects.length;
  },

  showSnackbar: function(text, longshow) {
    var snackbar = document.getElementById("snackbar");
    snackbar.innerHTML = text;
    if (longshow) {
      snackbar.className = "long-show";
      setTimeout(
        () =>
          (snackbar.className = snackbar.className.replace("long-show", "")),
        3000
      );
    } else {
      snackbar.className = "show";
      setTimeout(
        () => (snackbar.className = snackbar.className.replace("show", "")),
        3000
      );
    }
  },

  getClassForGrantApplicationStatus: function(statusId) {
    var grantClass = "new";
    switch (statusId) {
      case "2":
        grantClass = "started";
        break;
      case "3":
        grantClass = "applied";
        break;
      case "4":
        grantClass = "won";
        break;
      case "5":
        grantClass = "not-won";
        break;
    }

    return grantClass;
  },

  getGrantStatusClass: function(status) {
    switch (status) {
      case 0:
        return "no-status";
      case 1:
        return "awaiting-approval";
      case 2:
        return "production";
      case 3:
        return "errored";
      case 4:
        return "rejected";
      case 5:
        return "blacklisted";
    }
  },

  updateToggleIcon: function(iconId) {
    var icon = $(iconId);
    if (icon.text() == "add") {
      icon.text("remove");
    } else {
      icon.text("add");
    }
  },

  filterResponsesToShow: function(responseCategories, applicationResponses) {
    var responseIds = [];
    responseCategories.forEach(cat => {
      cat.Application_Template_Responses.forEach(resp => {
        responseIds.push(resp.Application_Template_Response_Id);
      });
    });
    return applicationResponses.filter(r =>
      responseIds.includes(
        r.Application_Template_Response.Application_Template_Response_Id
      )
    );
  },

  updateBudgetCol: function(col, sum) {
    col.v = sum;
    return "$" + parseFloat(sum).toLocaleString();
  },

  getBudgetTotal: function(budgetTableRows) {
    var total = 0;
    budgetTableRows.forEach(row => {
      total += row.c
        .filter(c => c.tot == true)
        .map(c => parseFloat(c.v))
        .reduce((a, b) => a + b, 0);
    });
    return "$" + parseFloat(total).toLocaleString();
  },

  getBudgetSectionTotal: function(budgetTableRows, firstColVal) {
    var sum = 0;
    var index = budgetTableRows.findIndex(r => r.c[0].v == firstColVal);
    var colToSum = budgetTableRows[0].c.length - 1;
    for (let i = index - 1; i > 0; i--) {
      if (budgetTableRows[i].st) {
        break;
      }
      sum += budgetTableRows[i].c[colToSum].v;
    }
    return sum;
  },

  getBudgetColType: function(typeIdentifier) {
    if (typeIdentifier == "n" || typeIdentifier == "d") {
      return "number";
    } else {
      return "text";
    }
  }
};

export { utilities };
